<template>
  <b-modal
    ref="partialOrderModal"
    title="Partial Order Warning"
    size="lg"
    @hidden="cleanup"
    hideFooter
  >
    <form @submit.prevent="submitRequest" v-if="!historyMode">
      <div class="row">
        <div class="col-12">
          <p class="float-left">Is order complete?</p>
          <b-form-checkbox
            class="float-right"
            v-model="checked"
            switch
            size="lg"
            >{{ checked ? "Yes" : "No" }}</b-form-checkbox
          >
        </div>
      </div>
      <div class="form-group" v-if="!checked">
        <label for="comment">Why did you partially pick the order?</label>
        <textarea
          ref="comment"
          :class="{
            'is-invalid': $v.comment.$invalid && submit,
            'is-valid': !$v.comment.$invalid && submit
          }"
          type="text"
          v-model="comment"
          class="form-control"
          id="comment"
          rows="4"
          style="resize: none;"
          aria-describedby="tracking_number_help"
          placeholder="Comment"
        ></textarea>
        <div class="invalid-feedback" v-if="!$v.comment.required">
          Please provide a comment
        </div>
      </div>
      <p v-if="!checked">
        Order in not fully picked, are you sure you want to proceed?
      </p>
      <div class="row w-100 m-0" style="clear: both;">
        <div class="modal-footer d-block w-100 p-0 pt-2">
          <button
            type="button"
            class="btn btn-warning text-white float-left"
            @click="toggleHistory"
          >
            View Order History
          </button>
          <button type="submit" class="btn btn-success float-right">
            Confirm
          </button>
          <button
            type="button"
            class="btn btn-secondary float-right"
            @click="hideModal"
          >
            Close
          </button>
        </div>
      </div>
    </form>
    <div v-else>
      <table
        class="table table-striped table-bordered"
        v-if="history.length > 0"
      >
        <thead>
          <tr>
            <th>Comment</th>
            <th style="width: 25%;">Date</th>
          </tr>
        </thead>
        <tbody>
          <tr :key="index" v-for="(item, index) of history">
            <td v-html="item.comment"></td>
            <td v-html="item.date_added"></td>
          </tr>
        </tbody>
      </table>
      <div v-else>
        No history recorded for this order yet.
      </div>
      <div class="row w-100 m-0" style="clear: both;">
        <div class="modal-footer d-block w-100">
          <button
            type="button"
            class="btn btn-secondary float-right"
            data-dismiss="modal"
            @click="toggleHistory"
          >
            Hide Order History
          </button>
        </div>
      </div>
    </div>
  </b-modal>
</template>

<script>
import { required } from "vuelidate/lib/validators";
export default {
  props: ["history"],
  name: "partial-order-modal",
  data() {
    return {
      checked: false,
      historyMode: false,
      comment: "",
      submit: false
    };
  },
  validations: {
    comment: {
      required
    }
  },
  methods: {
    cleanup() {
      this.comment = "";
      this.submit = false;
      this.checked = false;
      this.historyMode = false;
      this.$v.$reset;
    },
    toggleHistory() {
      this.historyMode = !this.historyMode;
    },
    submitRequest(evt) {
      this.submit = true;
      evt.preventDefault();

      if (this.checked || !this.$v.$invalid) {
        this.submit = false;
        this.$parent.handlePartialOrder({
          comment: this.comment,
          complete: this.checked
        });
        this.hideModal();
      }
    },
    showModal() {
      this.$refs.partialOrderModal.show();
    },
    hideModal() {
      this.$refs.partialOrderModal.hide();
    }
  }
};
</script>
<style>
table.table-bordered tr td p {
  margin: 0;
}
</style>
